import { compose } from 'redux';
import withRouteParams from 'hoc/withRouteParams';
import { connect } from 'react-redux';
import {
  getPersonalInfo,
  getBalanceToSettle,
  getActivePayMethod,
  getCallNotes,
  getNextPaymentAmount,
  getAllTransactions,
  getMembershipDue,
  getDefaultFeeDue,
} from 'ducks/customerDetails';
import { getGuarantorDetailsByAdfitNo } from 'ducks/guarantorDetails';
import { selectEntitiesByAdfitNo } from 'selectors/common';
import withScrollableTopTabs from 'hoc/withScrollableTopTabs';
import customerPageTopTabs from 'constants/customerPageTopTabs';
import CustomerDetails from './CustomerDetails';

const mapStateToProps = (state, ownProps) => ({
  customerDetails:
    state.customerDetails.adfitNo === ownProps.routeParams.adfitNo
      ? state.customerDetails
      : {},
  localisation: state.localisation,
  permissions: state.auth.permissions,
  guarantorDetails: selectEntitiesByAdfitNo(
    state.guarantorDetails,
    ownProps.routeParams.adfitNo
  ),
});

const mapDispatchToProps = {
  getPersonalInfo,
  getBalanceToSettle,
  getActivePayMethod,
  getNextPaymentAmount,
  getAllTransactions,
  getCallNotes,
  getMembershipDue,
  getDefaultFeeDue,
  getGuarantorDetailsByAdfitNo,
};

export default compose(
  withScrollableTopTabs(customerPageTopTabs, 0, ['adfitNo']),
  withRouteParams,
  connect(mapStateToProps, mapDispatchToProps)
)(CustomerDetails);
